import { render, staticRenderFns } from "./PostsSingle.vue?vue&type=template&id=33a3800c&scoped=true&lang=pug&"
import script from "./PostsSingle.vue?vue&type=script&lang=js&"
export * from "./PostsSingle.vue?vue&type=script&lang=js&"
import style0 from "./PostsSingle.vue?vue&type=style&index=0&id=33a3800c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3800c",
  null
  
)

export default component.exports